import React from 'react';
import { StarIcon } from 'lucide-react';
const testimonials = [{
  text: 'Ich unterrichte seit zwölf Jahren Jazz und Kindertanz und habe meine Stunden lange einzeln vorbereitet. Mit DANCE PRO™ konnte ich meine gesamte Semesterplanung in einem Wochenende strukturieren. Besonders die fertigen Stundenbilder und die Technikbibliothek geben mir endlich eine klare Grundlage – und ich gehe viel entspannter ins Studio.',
  author: 'Katharina M.',
  role: 'Tanzpädagogin für Jazz & Kindertanz, 38 Jahre'
}, {
  text: 'Als Leiter einer kleinen Tanzschule mit sieben Kursen pro Woche war ich ständig im Vorbereitungsmodus. Das Lesson Planner System ist für mich Gold wert: Ich stelle heute in kurzer Zeit eine sauber aufgebaute 60- oder 90-Minuten-Stunde zusammen und kann sie trotzdem auf meine Gruppen zuschneiden. Meine Elternkommunikation ist durch die Vorlagen ebenfalls professioneller geworden.',
  author: 'Daniel R.',
  role: 'Tanzschulleiter & Hip-Hop-Trainer, 44 Jahre'
}, {
  text: 'Ich bin noch am Anfang meiner Lehrtätigkeit und hatte oft das Gefühl, für jede Gruppe alles neu erfinden zu müssen. DANCE PRO™ gibt mir eine sichere Struktur, ohne dass mein Unterricht starr wirkt. Die Hinweise zu Progressionen helfen mir besonders bei meinen Teenagergruppen enorm.',
  author: 'Lea S.',
  role: 'Tanzlehrerin in Ausbildung, 26 Jahre'
}, {
  text: 'Meine Ballettschülerinnen sind sehr unterschiedlich weit. Die Student Development Programs haben mir geholfen, klare Ziele zu formulieren und Fortschritte sichtbar zu machen, ohne einzelne Kinder zu überfordern. Auch gegenüber Eltern kann ich Entwicklung jetzt viel nachvollziehbarer erklären.',
  author: 'Miriam K.',
  role: 'Ballettpädagogin, 47 Jahre'
}, {
  text: 'Der Choreografie-Bonus hat meine Vorbereitung wirklich verändert. Früher habe ich oft bis spät abends an Ideen gefeilt; heute nutze ich die Strukturen als kreativen Startpunkt und passe sie direkt an meine Contemporary-Gruppen an. Das spart Zeit und lässt mir wieder mehr Energie für die Menschen im Raum.',
  author: 'Jonas F.',
  role: 'Freier Contemporary-Tanzlehrer, 33 Jahre'
}];
export function Testimonials() {
  return <section className="border-y-4 border-brand-beigeDeep bg-brand-beige px-4 py-6 sm:px-6" data-id="element-135">
      <header className="mb-4 text-center" data-id="element-136">
        <h2 className="text-2xl font-bold leading-tight sm:text-3xl" data-id="element-137">
          STIMMEN AUS DEM TANZUNTERRICHT
        </h2>
        <p className="mt-1 text-sm font-bold text-brand-rose" data-id="element-138">
          Tanzlehrer gewinnen bereits Zeit, Klarheit und Sicherheit.
        </p>
      </header>
      <div className="space-y-3" data-id="element-139">
        {testimonials.map(testimonial => <article key={testimonial.author} className="rounded-md border border-brand-beigeDeep bg-brand-cream p-4 shadow-sm" data-id="element-140">
            <div className="mb-2 flex gap-0.5" data-id="element-141">
              {Array.from({
            length: 5
          }, (_, index) => <StarIcon key={index} className="h-3.5 w-3.5 fill-brand-gold text-brand-gold" data-id="element-142" />)}
            </div>
            <p className="text-[13px] font-medium leading-relaxed italic" data-id="element-143">
              „{testimonial.text}“
            </p>
            <div className="mt-3 flex items-center gap-2 border-t border-brand-beigeDeep pt-2" data-id="element-144">
              <span className="flex h-8 w-8 items-center justify-center rounded-full bg-brand-rose/20 text-sm font-bold text-brand-burgundy" data-id="element-145">
                {testimonial.author.charAt(0)}
              </span>
              <div data-id="element-146">
                <p className="text-sm font-bold text-brand-burgundy" data-id="element-147">
                  {testimonial.author}
                </p>
                <p className="text-[10px] font-bold uppercase tracking-wide text-brand-muted" data-id="element-148">
                  {testimonial.role}
                </p>
              </div>
            </div>
          </article>)}
      </div>
    </section>;
}